import { ArrowsClockwise as RefreshCw } from "@phosphor-icons/react";

export const CaddyErrorCard = () => (
  <div className="min-h-screen flex items-center justify-center px-6" style={{ background: "var(--pr-bg)" }} data-testid="caddy-error-card">
    <div className="max-w-sm w-full text-center">
      <h1 className="text-2xl mb-3" style={{ fontFamily: "'Fraunces', Georgia, serif", color: "var(--pr-ink)" }}>
        Hit a bump on the track
      </h1>
      <p className="text-sm leading-relaxed mb-6" style={{ color: "var(--pr-ink2)" }}>
        We couldn&rsquo;t reach Payday Relay just now, probably a slow connection. You&rsquo;re still signed in; give it another go.
      </p>
      <button
        onClick={() => window.location.reload()}
        className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full font-bold text-base transition-transform hover:scale-[1.02]"
        style={{ background: "var(--pr-gold)", color: "var(--pr-ink)" }}
        data-testid="caddy-error-retry"
      >
        <RefreshCw className="w-4 h-4" /> Try again
      </button>
    </div>
  </div>
);
